<template>
  <div class="bespoke-show">
    <section
      class="show-hero">
      <el-row>
        <grid-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="12"
          class="hero-image-container">
          <div class="image-container">
            <img
              :src="srcSet('src', heroImages)"
              :srcset="srcSet('srcset', heroImages)">
          </div>
        </grid-col>
        <grid-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="12"
          class="hero-text-container">
          <h1 v-html="heroHeader"/>
          <h3 v-html="heroSubheader" />
          <div class="hero-btns">
            <div
              class="play-trailer-btn"
              @click="playTrailer">
              <img
                v-if="isPlayingTrailer"
                src="../../assets/images/ic_pause_white_icon.svg"
                alt="Pause"
                class="pause-btn">
              <img
                v-else
                :class="{'play-btn': true, 'pulse': isLoadingTrailer }"
                src="../../assets/images/bespoke-play-btn.svg"
                alt="Play">
              <i
                v-if="false"
                class="el-icon-loading text-blue"/>
              <span>{{ playBtnText }}</span>
            </div>
            <div class="cta-btn">
              <button
                ref="cta"
                @click="() => handleCTAClick(stickyTs ? 'sticky' : 'hero')">
                {{ heroCTAText }}
              </button>
            </div>
          </div>
        </grid-col>
      </el-row>
    </section>
    <section class="show-carousel">
      <flickity
        ref="flickity"
        :options="flickityOptions">
        <img
          v-for="(srcSetImageGroup, index) in carouselImages"
          :key="`carousel-image-${index}`"
          :src="srcSet('src', srcSetImageGroup)"
          :srcset="srcSet('srcset', srcSetImageGroup)"
          class="carousel-image">
      </flickity>
    </section>
    <section class="show-more-info">
      <div class="content-container">
        <h1 v-if="!isXsViewport">Created in the Dark of Night</h1>
        <h1 v-else>Created in the <br>Dark of Night</h1>
        <p>Be afraid. Spooked is back with more hair-raising supernatural stories than ever. Hosted by Glynn Washington, Season 4 includes a special spring run of episodes, with even more creeping up this fall. Subscribe to Luminary with an annual plan to listen to them all.</p>
        <div class="cta-btn">
          <button
            @click="() => handleCTAClick('sub-now-btn')">
            Subscribe Now
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import * as log from 'loglevel';
import Flickity from 'vue-flickity';
import throttle from 'lodash/throttle';
import Podcast from '../../services/Podcast';
import PageMixin from '../../shared/pageMixin';
import Event from '../../services/PlayerEvent';
import heroImage1x from '../../assets/images/spooked/hero-sq@1x.jpg';
import heroImage2x from '../../assets/images/spooked/hero-sq@2x.jpg';
import carousel1Img1x from '../../assets/images/spooked/carousel_01@1x.jpg';
import carousel1Img2x from '../../assets/images/spooked/carousel_01@2x.jpg';
import carousel2Img1x from '../../assets/images/spooked/carousel_02@1x.jpg';
import carousel2Img2x from '../../assets/images/spooked/carousel_02@2x.jpg';
import carousel3Img1x from '../../assets/images/spooked/carousel_03@1x.jpg';
import carousel3Img2x from '../../assets/images/spooked/carousel_03@2x.jpg';


export default {
  name: 'BespokeShow',
  components: {
    Flickity,
  },
  mixins: [PageMixin],
  data() {
    return {
      season_trailers: [],
      stickyCTA: false,
      stickyTs: null,
      podcast_service: new Podcast(),
      eventProvider: new Event(),
      display_image_url: 'https://img4.luminarypodcasts.com/v1/podcast/ddef3227-882b-40a3-be76-fafd0d71424f/thumbnail/h_360,w_360/image/s--SpVoAiHV--/aHR0cHM6Ly9tZWdhcGhvbmUtcHJvZC5zMy5hbWF6b25hd3MuY29tL3BvZGNhc3RzLzY3OGQxNmE2LTVmYzctMTFlOS04NTUxLThiODU4NWQyODEyMy9pbWFnZS91cGxvYWRzXzJGMTU4MjgzMTM5MTU2MS11eGFnNW9odzdxLTYwNjkwMmVhMTUyYmEzZmZlOTg3ODA1MmIyYWZlYjc0XzJGc2Vhc29uNC1zcS5qcGc=.jpg?dpr=2',
      showUUID: 'ddef3227-882b-40a3-be76-fafd0d71424f',
      windowWidth: null,
      windowHeight: null,
      heroImages: [heroImage1x, heroImage2x],
      heroHeader: 'Spooked: Season 4',
      heroSubheader: 'True-life supernatural stories, told firsthand by people who can barely believe it happened themselves.',
      heroCTAText: 'Start Free Trial',
      carouselImages: {
        img1: [carousel1Img1x, carousel1Img2x],
        img2: [carousel2Img1x, carousel2Img2x],
        img3: [carousel3Img1x, carousel3Img2x],
      },
      isPlaying: false,
    };
  },
  computed: {
    isMdViewport() {
      return this.windowWidth >= 1024;
    },
    isXsViewport() {
      return this.windowWidth <= 576;
    },
    playBtnText() {
      return `${this.isPlaying ? 'Pause' : 'Play'} Trailer`;
    },
    isLoading() {
      return false;
    },
    flickityOptions() {
      return {
        prevNextButtons: false,
        draggable: window.innerWidth < 1024,
        contain: true,
        pageDots: false,
      };
    },
    currentlyPlaying() {
      return this.$store.getters.episode;
    },
    isLoadingTrailer() {
      const { status } = this.$store.getters;

      return this.season_trailers.length && status === 'loading' && this.currentlyPlaying && (this.currentlyPlaying.uuid === this.season_trailers[0].uuid);
    },
    isPlayingTrailer() {
      const { play } = this.$store.getters;
      if (!this.season_trailers) {
        return false;
      }
      return this.season_trailers.length && play && this.currentlyPlaying && (this.currentlyPlaying.uuid === this.season_trailers[0].uuid);
    },
  },
  watch: {
    /* eslint-disable */
    windowHeight: function (newHeight) {
      this.adjustStickyCta();
    },
    /* eslint-enable */
  },
  beforeMount() {
    this.getSeasonTrailers();
  },
  mounted() {
    if (!this.$store.getters.hidePlayer) {
      this.togglePlayerVisiblity(true);
    }
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    });
    window.addEventListener('scroll', () => this.handleScroll());
    window.addEventListener('scroll', throttle(this.checkVisibleSections, 1000));
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.togglePlayerVisiblity(true);
      vm.addNoIndexMeta();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.togglePlayerVisiblity(false);
    this.removeNoIndexMeta();
    next();
  },
  methods: {
    handleCTAClick(btnId) {
      const { isFreeUser, isPremiumUser } = this.promoMeta;
      const routeTo = { path: '/signup' };
      if (isFreeUser) {
        routeTo.path = '/plans';
      } else if (isPremiumUser) {
        routeTo.path = '/listen/snap-judgment-and-wnyc-studios/snap-judgment-presents-spooked-710/ddef3227-882b-40a3-be76-fafd0d71424f';
      }
      this.$analytics.track('Bespoke CTA Click', {
        screen_name: this.$route.name,
        path: this.$route.path,
        btnId,
      });
      this.$router.push(routeTo);
    },
    adjustStickyCta() {
      if (this.$refs.cta && this.stickyTs && this.isXsViewport) {
        this.$refs.cta.style.top = `${window.innerHeight - 110}px`;
      }
    },
    togglePlayerVisiblity(bool) {
      this.$store.dispatch('toggleHidePlayer', bool);
    },
    checkVisibleSections() {
      if (!this.viewTracker) {
        this.viewTracker = [...document.getElementsByTagName('section')]
          .map(section => section.className)
          .reduce((tracker, sectionName) => {
            tracker[sectionName] = false;
            return tracker;
          }, {});
      }
      const ctx = this;
      Object.entries(this.viewTracker)
        .forEach(([secName, hasViewed]) => {
          if (hasViewed) {
            return;
          }
          const e = document.getElementsByClassName(secName) && document.getElementsByClassName(secName)[0];
          const isVisible = (e && e.getBoundingClientRect() && e.getBoundingClientRect().y < window.innerHeight) || false;
          if (isVisible) {
            ctx.viewTracker[secName] = true;
            ctx.$analytics.track('Scrolled Into View', {
              screen_name: ctx.$route.name,
              path: ctx.$route.path,
              section: secName,
            });
          }
        });
    },
    handleScroll() {
      if (!this.isXsViewport) {
        return;
      }
      const ctaYPos = (this.$refs.cta && this.$refs.cta.getBoundingClientRect().y) || 1000;
      const ctaXPos = (this.$refs.cta && this.$refs.cta.getBoundingClientRect().x) || 1000;
      const viewPortThreshold = window.innerHeight - 110;
      const isSticky = ctaYPos < viewPortThreshold;
      const refParentDivYPos = (this.$refs.cta && this.$refs.cta.parentElement && this.$refs.cta.parentElement.getBoundingClientRect().y) || 1000;
      if (isSticky && !this.stickyTs) {
        this.$refs.cta.style.top = `${window.innerHeight - 110}px`;
        this.$refs.cta.style.left = `${ctaXPos}px`;
        this.$refs.cta.style.position = 'fixed';
        this.stickyTs = Date.now();
      }
      if (refParentDivYPos > viewPortThreshold && this.stickyTs && (Date.now() - this.stickyTs > 1000)) {
        this.$refs.cta.style.top = 'unset';
        this.$refs.cta.style.left = 'unset';
        this.$refs.cta.style.position = 'relative';
        this.stickyTs = null;
      }
    },
    next() {
      this.$refs.flickity.next();
    },
    previous() {
      this.$refs.flickity.previous();
    },
    playPauseTrailer() {
      this.isPlaying = !this.isPlaying;
    },
    playTrailer() {
      const trailer = this.season_trailers[0];
      trailer.episode_type = 'trailer';
      trailer.display_image_url = this.display_image_url;
      trailer.playedFrom = 'bespoke_sdp';
      this.togglePlayerVisiblity(true);
      if (this.currentlyPlaying.uuid === trailer.uuid && this.currentlyPlaying.playedFrom === trailer.playedFrom) {
        const { play } = this.$store.getters;

        if (!play) {
          if (this.currentlyPlaying.episode_type !== 'trailer') {
            this.eventProvider.triggerEpisodePauseEvent(this.currentlyPlaying, 'trailer_select');
          }
          this.$store.dispatch('play');
          this.eventProvider.triggerTrailerPlayEvent(trailer, 'sdp_select');
        } else {
          this.$store.dispatch('pause');
          this.eventProvider.triggerTrailerPauseEvent(trailer, 'sdp_pause');
        }
      } else {
        this.$store.dispatch('setTrailerAsEpisode', false);

        if (this.currentlyPlaying.episode_type !== 'trailer') {
          this.eventProvider.triggerEpisodePauseEvent(this.currentlyPlaying, 'trailer_select');
        }
        this.$store.dispatch('setTrailerExperienceTriggered', false); // Make sure trailer experience does not trigger from here.
        this.loadMediaInPlayer(trailer.media_url, trailer.is_exclusive, trailer.episode_type, true);
        this.$store.dispatch('setNextEpisode', {}); // Empty next episode because playback should stop after trailer complete from SDP.
        this.$store.dispatch('setAndPlayEpisode', trailer);
        this.eventProvider.triggerTrailerPlayEvent(trailer, 'sdp_select');
      }
    },
    getSeasonTrailers() {
      this.podcast_service
        .getPodcastTrailers(this.showUUID)
        .then((res) => {
          this.season_trailers = res.trailers || [];
          this.season_trailers = this.season_trailers.sort((a, b) => new Date(b.released_at) - new Date(a.released_at));
        })
        .catch((error) => {
          log.error(error);
        });
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../assets/scss/variables.scss";

.bespoke-show {
  background-color: #0b0b0b;
  color: white;
  font-family: 'Georgia', Georgia, serif;
  display: flex;
  flex-direction: column;
  p, h1, h3, button {
    font-family: 'Georgia', Georgia, serif;
    color: white;
  }
  .hidden-div {
    visibility: hidden;
  }
  .sticky-div {
    position: fixed;
    .cta-btn {
      display: flex;
      @media(max-width: $md) {
        width: 100%;
        justify-content: center;
        margin-bottom: 28px;
      }
      width: 50%;
      color: black;
      button {
        width: 251px;
        height: 55px;
        background-color: #fff;
        font-size: 17px;
        text-align: center;
        border: 0;
        border-radius: 30px;
        color: black;
      }
    }
  }
  .show-hero {
    margin-right: auto;
    margin-left: auto;
    padding-top: 78px;
    padding-bottom: 78px;
    width: 95vw;
    max-width: 1138px;
    background-color: #0b0b0b;
    @media(max-width: $xs) {
      width: 100%;
      padding-top: 0px;
      padding-bottom: 16px;
    }
    .hero-image-container {
      .image-container {
        width: 100%;
        display: flex;
        @media(max-width: $md) {
          justify-content: center;
        }
        @media(max-width: $xs) {
          width: 100vw;
          height: 100vw;
        }
        img {
          width: 100%;
          @media(max-width: $xs) {
            object-fit: contain;
          }
          @media(min-width: $xs) {
            width: 520px;
          }
          @media(min-width: 1024px) and (max-width: 1200px) {
            max-width: 85%;
          }
        }
      }
    }
    .hero-text-container {
      padding-left: 16px;
      padding-right: 16px;
      @media(min-width: 1024px) and (max-width: 1200px) {
        padding-left: 8px;
        padding-right: 8px;
      }
    }
    h1 {
      font-weight: 400;
      margin-top: 52px;
      font-size: 48px;
      line-height: 46px;
      margin-bottom: 32px;
      @media(max-width: $md) {
        margin-top: 24px;
        margin-bottom: 16px;
        text-align: center;
        font-size: 48px;
        line-height: 46px;
      }
      @media(max-width: $sm) {
        font-size: 30px;
        line-height: 46px;
      }
      @media(min-width: 1024px) and (max-width: 1200px) {
        margin-top: 36px;
      }
    }
    h3 {
      font-weight: 400;
      font-size: 32px;
      line-height: 39px;
      margin-bottom: 69px;
      @media(max-width: $sm) {
        font-size: 22px !important;
        line-height: 33px !important;
      }
      @media(max-width: $md) {
        max-width: 75%;
        margin-left: auto;
        margin-right: auto;
        font-size: 32px;
        line-height: 39px;
        text-align: center;
        margin-bottom: 24px;
      }
    }
    .hero-btns {
      display: flex;
      @media(max-width: $xs) {
        flex-direction: column;
        justify-content: center;
      }
      .play-trailer-btn {
        width: 50%;
        display: flex;
        align-items: center;
        @media(max-width: $md) {
          width: 100%;
          justify-content: center;
          margin-bottom: 28px;
        }
        img, svg {
          width: 59px;
          height: 59px;
          margin-right: 19px;
        }
        span {
          font-size: 17px;
        }
        .pause-btn {
          transform: scale(.5) translateX(-3px);
        }
      }
      .cta-btn {
        display: flex;
        z-index: 9980;
        height: 55px;
        @media(max-width: $md) {
          width: 100%;
          justify-content: center;
          margin-bottom: 28px;
        }
        width: 50%;
        button {
          transition: 500ms ease-in-out all;
          width: 251px;
          height: 55px;
          background-color: #fff;
          font-size: 17px;
          text-align: center;
          border: 0;
          border-radius: 30px;
          color: black;
        }
      }
    }
  }
  .show-carousel {
    background-color: #0b0b0b;
    height: 322px;
    width: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    img {
      height: 322px;
      width: 430px;
    }
  }
  .show-more-info {
    background-color: #0b0b0b;
    .content-container {
      max-width: 1280px;
      margin-left: auto;
      margin-right: auto;
      padding-top: 24px;
      h1 {
        font-size: 48px;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        line-height: 56px;
        @media(max-width: $xs) {
          margin-left: auto;
          margin-right: auto;
          max-width: 75%;
          font-size: 30px;
          line-height: 46px;
        }
      }
      p {
        margin-left: auto;
        margin-right: auto;
        display: block;
        max-width: 75%;
        text-align: left;
        font-size: 24px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 36px;
        box-sizing: border-box;
        @media(max-width: $xs) {
          font-size: 18px;
          line-height: 28px;
          padding: 0 8px;
        }
      }
      .cta-btn {
        display: flex;
        justify-content: center;
        padding: 48px 0 120px;
        flex-grow: 1;
        @media(max-width: $xs) {
          padding-bottom: 40px;
        }
        button {
          width: 251px;
          height: 55px;
          background-color: #fff;
          font-size: 20px;
          font-weight: 400;
          text-align: center;
          border: 0;
          border-radius: 30px;
          color: black;
          @media(max-width: $xs) {
            display: none;
          }
        }
      }
    }
  }
  .pulse {
    animation-name: pulse;
    animation-duration: 800ms;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
  }
}
@keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}
</style>
